import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "@/features/api/ApiSlice";
import authReducer from "@/features/auth/AuthSlice";
import sidePanelReducer from "@/features/SidePanelSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    sidePanel: sidePanelReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(
      apiSlice.middleware
    ),
});

export type AppStore = typeof store;
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];

export default store;
